import React from 'react'
import { AuthState, ModalForgotPasswordData } from 'typings/auth'
import { Clock, Refresh } from '@dasa-health/alma-icons'

export const EMPTY_DATA_USER: AuthState = {
    token: null,
    refreshToken: null,
    signed: false,
    user: null,
    limitedFlow: false,
    keepLogged: {
        keepLogged: false,
        latitude: undefined,
        longitude: undefined,
        address: undefined,
        uuid: undefined,
        patientId: undefined,
        username: undefined,
    },
}

export const MODAL_FORGOT_PASSWORD_DATA: ModalForgotPasswordData = {
    title: 'Esqueci a senha',
    subtitle: 'Selecione a opção que deseja prosseguir:',
    itens: [
        {
            icon: <Clock />,
            title: 'Entrar sem senha',
            subtitle: 'Enviaremos para você um código de acesso único.',
            type: 'OTP',
        },
        {
            icon: <Refresh />,
            title: 'Criar nova senha',
            subtitle: 'Crie uma senha segura para acessar o Nav Dasa sempre que você precisar.',
            type: 'PASSWORD',
        },
    ],
}
